import { createServerFn } from "@tanstack/react-start";
import { getDiscovery } from "@/lib/core/discovery-core.server";

export const serverReverseGeocode = createServerFn({ method: "GET" })
    .inputValidator((data: { lat: number; lng: number }) => data)
    .handler(async ({ data }) => {
        const discovery = await getDiscovery();
        return await discovery.geo.reverseGeocode(data);
    });

export const serverGeocodeAddress = createServerFn({ method: "GET" })
    .inputValidator((data: { address: string }) => data)
    .handler(async ({ data }) => {
        const discovery = await getDiscovery();
        return await discovery.geo.geocodeAddress(data);
    });
